import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=bd3640da&scoped=true"
import script from "./authLayout.vue?vue&type=script&lang=js"
export * from "./authLayout.vue?vue&type=script&lang=js"
import style0 from "./authLayout.vue?vue&type=style&index=0&id=bd3640da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3640da",
  null
  
)

export default component.exports